import {performGQL} from "../functions";
const updateAdminBackendUsers = /* GraphQL */ `
  mutation UpdateAdminBackendUsers(
    $input: UpdateAdminBackendUsersInput!
    $condition: ModelAdminBackendUsersConditionInput
  ) {
    updateAdminBackendUsers(input: $input, condition: $condition) {
        id
        firstName
        surname
        sub
        color
        email
        phone
        mailAccount
        taskFolders
        lastActive
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      __typename
    }
  }
`;
const updateBackendUser = (input ) => {
    const variables = {input}
    return performGQL(variables, updateAdminBackendUsers)
}
export default updateBackendUser;